<template>
  <div>
    <Nav></Nav>
    <b-container fluid>
      <b-row>
        <b-col class="text-left">
          <h1>{{ actualManufacturingOrder.name }}<p>ID: {{ actualManufacturingOrder.id }}</p>
          </h1>
        </b-col>
      </b-row>
      <b-row class="text-left">
        <b-col>
          <b-button :disabled="lockButtons" v-show="actualManufacturingOrder.state == 'draft'"
            @click="sendPO('confirm')" size="sm mr-3" variant="success" class="ml-2 mb-2">
            Confirmar
          </b-button>
          <b-button :disabled="lockButtons" v-show="actualManufacturingOrder.state == 'confirmed'"
            @click="sendPO('start')" size="sm mr-3" variant="success" class="ml-2 mb-2">
            Iniciar Proceso
          </b-button>
          <b-button :disabled="lockButtons" v-show="actualManufacturingOrder.state == 'in_progress'"
            @click="sendPO('complete')" size="sm mr-3" variant="success" class="ml-2 mb-2">
            Terminar Proceso
          </b-button>
          <b-button :disabled="lockButtons" v-show="actualManufacturingOrder.state != 'cancel'"
            @click="sendPO('cancel')" size="sm mr-3" variant="danger" class="ml-2 mb-2">
            Cancelar
          </b-button>
          <b-button :disabled="lockButtons" v-show="actualManufacturingOrder.state != 'draft' && actualManufacturingOrder.state != 'cancelled'"
            @click="sendPO('revert')" size="sm mr-3" variant="warning" class="ml-2 mb-2">
            Revertir
          </b-button>
        </b-col>
        <b-col>
          <progress-steps :steps="processSteps" :currentStep="actualManufacturingOrder.state || ''"></progress-steps>
        </b-col>
      </b-row>
      <b-card class="my-2 p-1">
        <b-row>
          <b-col lg="6" md="12">
            <table class="table table-borderless text-left table-sm">
              <tbody>
                <tr>
                  <td><b>Sucursal:</b></td>
                  <td>{{ actualManufacturingOrder.sucursal_id }}</td>
                </tr>
                
                <tr>
                  <td><b>Status:</b></td>
                  <td><b-badge :variant="statusBadge(actualManufacturingOrder.state).variant">{{
                    statusBadge(actualManufacturingOrder.state).text }}</b-badge></td>
                </tr>
                <tr>
                  <td><b>Creado Por:</b></td>
                  <td>{{ actualManufacturingOrder.create_uid }}</td>
                </tr>
              </tbody>
            </table>
          </b-col>
          <b-col lg="6" md="12">
            <table class="table  table-borderless text-left table-sm">
              <tbody>
                <tr>
                  <td><b>Fecha de Creación:</b></td>
                  <td>{{ actualManufacturingOrder.create_date }}</td>
                </tr>
                <tr>
                  <td><b>Fecha de entrega:</b></td>
                  <td>{{ actualManufacturingOrder.date_planned_start }}</td>
                </tr>
                <tr>
                  <td><b>Fecha de Orden:</b></td>
                  <td>{{ actualManufacturingOrder.date_planned_finished }}</td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <h4>Por Consumir</h4>
            <table class="table table-sm text-left table-responsive">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Codigo</th>
                  <th>Producto</th>
                  <th>Cantidad</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in actualManufacturingOrderItemsRaw" v-bind:key="item.id">
                  <td>{{ item.id }}</td>
                  <td>{{ item.supply.code }}</td>
                  <td>{{ item.supply.name }}</td>
                  <td>
                    <div v-if="editingItem === item.id" class="d-flex align-items-center">
                      <b-input-group size="sm" style="max-width: 120px;">
                        <b-form-input 
                          v-model.number="editQuantity" 
                          type="number" 
                          step="0.01"
                          min="0"
                        ></b-form-input>
                      </b-input-group>
                      <span class="mx-2">/{{ item.product_qty }}</span>
                    </div>
                    <span v-else>{{ item.product_qty }}</span>
                  </td>
                  <td>
                    <b-badge :variant="getStockMoveStatusVariant(item.state)">{{ getStockMoveStatusText(item.state) }}</b-badge>
                  </td>
                  <td>
                    <div v-if="editingItem === item.id">
                      <b-button size="sm" variant="success" @click="saveQuantity(item)" class="mr-1">
                        ✓
                      </b-button>
                      <b-button size="sm" variant="secondary" @click="cancelEdit()">
                        ✕
                      </b-button>
                    </div>
                    <div v-else>
                      <b-button size="sm" variant="outline-primary" @click="startEdit(item)" 
                                :disabled="!canEditStockMove(item)">
                        ✏️
                      </b-button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
          <b-col>
            <h4>Por Elaborar</h4>
            <table class="table table-sm text-left table-responsive">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Codigo</th>
                  <th>Producto</th>
                  <th>Cantidad</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in actualManufacturingOrderItemsCons" v-bind:key="item.id">
                  <td>{{ item.id }}</td>
                  <td>{{ item.supply.code }}</td>
                  <td>{{ item.supply.name }}</td>
                  <td>
                    <div v-if="editingItem === item.id" class="d-flex align-items-center">
                      <b-input-group size="sm" style="max-width: 120px;">
                        <b-form-input 
                          v-model.number="editQuantity" 
                          type="number" 
                          step="0.01"
                          min="0"
                        ></b-form-input>
                      </b-input-group>
                      <span class="mx-2">/{{ item.product_qty }}</span>
                    </div>
                    <span v-else>{{ item.product_qty }}</span>
                  </td>
                  <td>
                    <b-badge :variant="getStockMoveStatusVariant(item.state)">{{ getStockMoveStatusText(item.state) }}</b-badge>
                  </td>
                  <td>
                    <div v-if="editingItem === item.id">
                      <b-button size="sm" variant="success" @click="saveQuantity(item)" class="mr-1">
                        ✓
                      </b-button>
                      <b-button size="sm" variant="secondary" @click="cancelEdit()">
                        ✕
                      </b-button>
                    </div>
                    <div v-else>
                      <b-button size="sm" variant="outline-primary" @click="startEdit(item)" 
                                :disabled="!canEditStockMove(item)">
                        ✏️
                      </b-button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </b-card>
    </b-container>
  </div>
</template>
<style>
.table-borderless>tbody>tr>td,
.table-borderless>tbody>tr>th,
.table-borderless>tfoot>tr>td,
.table-borderless>tfoot>tr>th,
.table-borderless>thead>tr>td,
.table-borderless>thead>tr>th {
  border: none;

}
</style>
<script>
import axios from "axios";
import Nav from "../components/Nav.vue";
import ProgressSteps from "../components/ProgressSteps.vue";
export default {
  name: "ManufacturingOrder",
  components: {
    Nav, ProgressSteps
  },

  data() {
    return {
      lockButtons: false,
      processSteps: [
        { name: "draft", label: "Borrador" },
        { name: "confirmed", label: "Confirmado" },
        { name: "in_progress", label: "En Proceso" },
        { name: "done", label: "Hecho" },
        { name: "cancelled", label: "Cancelado" },
      ],
      editingItem: null,
      editQuantity: 0,
      actualManufacturingOrder: {
        bom_id: null,
        company_id: null,
        create_date: null,
        create_uid: null,
        date_finished: null,
        date_planned_finished: null,
        date_planned_start: null,
        date_start: null,
        id: null,
        location_dest_id: null,
        location_src_id: null,
        name: null,
        product_qty: null,
        qty_producing: null,
        state: null,
        sucursal_id: null,
        supply_id: null,
        write_date: null,
        write_uid: null
      },
      actualManufacturingOrderItems: [],
      actualManufacturingOrderItemsCons: [],
      actualManufacturingOrderItemsRaw: [],

    };
  },

  computed: {

  },
  watch: {},
  mounted() {
    if (this.$route.params.id > 0) {
      this.actualManufacturingOrder.id = this.$route.params.id;
      this.getCompra()
      this.getCompraItems()
    }
  },
  created() {

  },
  methods: {
    statusBadge(status) {
      let rtn = { variant: "", text: status }
      switch (status) {
        case "draft":
          rtn.variant = "warning"
          rtn.text = "Borrador"
          break;
        case "confirmed":
          rtn.variant = "warning"
          rtn.text = "Confirmado"
          break;
        case "in_progress":
          rtn.variant = "info"
          rtn.text = "En Proceso"
          break;
        case "done":
          rtn.variant = "success"
          rtn.text = "Terminado"
          break;
        case "cancelled":
          rtn.variant = "danger"
          rtn.text = "Cancelado"
          break;
      }
      return rtn
    },
    canEditStockMove(item) {
      // Can edit stock moves based only on their individual state
      // Draft: Can be edited freely
      // Waiting availability: Can be edited to adjust planned quantities
      // Assigned: Can be edited but will trigger inventory recalculation
      const allowedStockMoveStates = ['draft', 'waiting_availability', 'assigned']
      return allowedStockMoveStates.includes(item.state)
    },
    getStockMoveStatusVariant(state) {
      const variants = {
        'draft': 'secondary',
        'waiting_availability': 'warning', 
        'assigned': 'info',
        'partially_available': 'warning',
        'done': 'success',
        'cancel': 'danger'
      }
      return variants[state] || 'secondary'
    },
    getStockMoveStatusText(state) {
      const texts = {
        'draft': 'Borrador',
        'waiting_availability': 'Esperando',
        'assigned': 'Asignado', 
        'partially_available': 'Parcial',
        'done': 'Terminado',
        'cancel': 'Cancelado'
      }
      return texts[state] || state
    },
    startEdit(item) {
      if (!this.canEditStockMove(item)) {
        this.makeToast("warning", "Advertencia", "No se puede editar este movimiento en su estado actual")
        return
      }
      this.editingItem = item.id
      this.editQuantity = item.product_qty
    },
    cancelEdit() {
      this.editingItem = null
      this.editQuantity = 0
    },
    saveQuantity(item) {
      let that = this
      
      // Validate the new quantity
      if (this.editQuantity < 0) {
        this.makeToast("danger", "Error", "La cantidad no puede ser negativa")
        return
      }
      
      // Only update the product_qty field and maintain other critical fields
      const payload = {
        ...item,
        product_qty: this.editQuantity,
        write_date: new Date().toISOString().slice(0, 19).replace('T', ' ')
      }
      
      // Remove any undefined or null nested objects that might cause issues
      if (payload.supply) {
        delete payload.supply
      }
      
      axios.put(`/stockmove/${item.id}`, payload)
        .then(function () {
          that.editingItem = null
          that.editQuantity = 0
          that.getCompraItems()
          
          // If the stock move was in assigned state, it might have triggered a refresh
          if (item.state === 'assigned') {
            that.makeToast("success", "Actualizado", "Cantidad actualizada e inventario recalculado")
          } else {
            that.makeToast("success", "Actualizado", "Cantidad actualizada exitosamente")
          }
        })
        .catch(function (error) {
          console.log(error.response)
          let errorMsg = "Error al actualizar la cantidad"
          if (error.response && error.response.data) {
            errorMsg = error.response.data
          }
          that.makeToast("danger", "Error", errorMsg)
        })
    },
    sendPO(action) {
      this.$bvModal.msgBoxConfirm('Seguro que quieres cambiar de status', {
        title: 'Confirmacion',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'Si',
        cancelTitle: "No",
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
        .then(value => {
          if (value) {
            this.lockButtons = true
            let that = this
            axios.post('/manufacturingorder/' + this.actualManufacturingOrder.id + '/' + action)
              .then(function () {
                that.getCompra()
                that.getCompraItems()
                that.makeToast("success", "Enviado", "exito")
                that.lockButtons = false
              })
              .catch(function (error) {
                that.makeToast("danger", "Error", error.response.data);
                that.lockButtons = false
              });
          }

        })
        .catch(err => {
          console.log(err)
        })

    },
    getCompra() {
      let that = this
      axios.get("/manufacturingorder/" + this.actualManufacturingOrder.id)
        .then(function (res) {
          that.actualManufacturingOrder = res.data
        }).catch(function (err) {
          that.makeToast("danger", "Error", err.response.data)
        })
    },
    getCompraItems() {
      let that = this
      axios.get("/manufacturingorder/" + this.actualManufacturingOrder.id + "/items")
        .then(function (res) {
          that.actualManufacturingOrderItems = res.data
          that.actualManufacturingOrderItemsRaw = res.data.filter((x)=>x.raw_manufacturing_order_id>0)
          that.actualManufacturingOrderItemsCons = res.data.filter((x)=>x.manufacturing_order_id>0)
          
        }).catch(function (err) {
          that.makeToast("danger", "Error", err.response.data)
        })
    },
    makeToast(variant = null, title = "", text = "") {
      if (variant == "success") {
        this.$bvToast.toast(text, {
          title: title,
          variant: variant,
          solid: true,
          appendToast: true,
        });
      } else {
        this.$bvModal.msgBoxOk(text, {
          title: title,
          okVariant: variant,
          centered: true
        })
      }
    },
  },
};
</script>
